import { HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiConfiguration as AccessNumbersApiConfiguration } from 'src/app/api/access-number-api/api-configuration';
import { ApiConfiguration as ClientApiConfiguration } from 'src/app/api/client-api/api-configuration';
import { ApiConfiguration as FeatureFlagsApiConfiguration } from 'src/app/api/feature-flag-api/api-configuration';
import { ApiNames, DataChanged } from 'src/app/api/notification-api/models';
import { NotificationService } from 'src/app/api/notification-api/services';
import { ApiConfiguration as OperationApiConfiguration } from 'src/app/api/operation-api/api-configuration';
import { ApiConfiguration as ProvidedServicesApiConfiguration } from 'src/app/api/provided-services-api/api-configuration';
import { ApiConfiguration as StorageApiConfiguration } from 'src/app/api/storage-api/api-configuration';
import { DataChangeService } from '../data-changed/data-changed.service';

@Injectable({
	providedIn: 'root'
})
export class SignalRService {
	private notificationService = inject(NotificationService);
	private clientApiConfiguration = inject(ClientApiConfiguration);
	private featureFlagsApiConfiguration = inject(FeatureFlagsApiConfiguration);
	private storageApiConfiguration = inject(StorageApiConfiguration);
	private providedServicesApiConfiguration = inject(
		ProvidedServicesApiConfiguration
	);
	private operationApiConfiguration = inject(OperationApiConfiguration);
	private accessNumbersApiConfiguration = inject(
		AccessNumbersApiConfiguration
	);
	private dataChangeService = inject(DataChangeService);

	private urlApiNameMapping: object = {
		[this.clientApiConfiguration.rootUrl]: ApiNames.Client,
		[this.featureFlagsApiConfiguration.rootUrl]: ApiNames.FeatureFlags,
		[this.storageApiConfiguration.rootUrl]: ApiNames.Disclaimers,
		[this.providedServicesApiConfiguration.rootUrl]: ApiNames.AccessNumbers,
		[this.operationApiConfiguration.rootUrl]: ApiNames.Client,
		[this.accessNumbersApiConfiguration.rootUrl]: ApiNames.AccessNumbers,
		[this.storageApiConfiguration.rootUrl]: ApiNames.Storage
	};

	async dataChanged(request: HttpRequest<any>): Promise<void> {
		if (
			!request ||
			!['POST', 'PUT', 'DELETE', 'PATCH'].includes(request.method)
		) {
			return;
		}

		const apiName: ApiNames = this.getApiName(request.url);
		if (!apiName) {
			return;
		}

		this.dataChangeService.notifyDataChanged(apiName);

		await this.notificationService
			.postNotificationsDatachanged({
				body: { apiName: apiName } as DataChanged
			})
			.toPromise();
	}

	private getApiName(url: string): ApiNames {
		const foundKey = Object.keys(this.urlApiNameMapping).find((key) =>
			url.includes(key)
		);
		return foundKey ? this.urlApiNameMapping[foundKey] : null;
	}
}
